<template>
	<div class="col-5">
		<h4 style="margin-bottom: 1.7rem; text-align: left;">Choose the AV(s):</h4>
		<div class="av-selection">
			<div class="av-checkboxes">
				<div class="av-checkbox bounce" v-for="av in avs" :key="av.name">
					<input 
						type="checkbox" 
						:id="'checkbox-' + av.name" 
						:value="av.name"
						:checked="av.checked"
						v-model="av.checked"
					/>
					<svg viewBox="0 0 21 21">
						<polyline points="5 10.75 8.5 14.25 16 6"></polyline>
					</svg>
					<label :for="'checkbox-' + av.name">
						{{ av.name }}
					</label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AvSelector',
		data() {
			return {
				avs: [{
					name: 'kaspersky',
					checked: true,
				}, {
					name: 'avast',
					checked: true,
				},{
					name: 'eset',
					checked: false,
				},{
					name: 'avira',
					checked: false,
				}],
				valueToSend: []
			}
		},
		methods: {
			getItems() {
				this.updateValue(this.avs)
			},
			updateValue: function (value) {
				this.$emit('selected', value)
			}
		},
		mounted() {
			this.getItems()
		},
		watch: {
			avs: {
				deep: true,
				handler(val) {
					this.updateValue(val)
				}
			}
		}
	}
</script>